import { forceResetAccountPassword } from 'user/resources/user.api';
import { checkAccess } from 'app/actions/app.actions';
import resetPasswordButtonTemplate from './reset-password-button.html';
import resetPasswordDialogTemplate from './reset-password-confirm-dialog.html';

const mapDispatchToThis = {
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', 'gettextCatalog', 'Notifications')
class ResetPasswordButtonController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(null, mapDispatchToThis)(this);
  }

  $onInit() {
    this.canUseResetForm = this.checkAccess('user.canUseResetForm');
  }

  $onDestroy() {
    this.unsubscribe();
  }

  resetPassword() {
    return this.canUseResetForm ? this.onShowResetPasswordConfirm() : this.forceSubmitForm();
  }

  forceSubmitForm() {
    forceResetAccountPassword(this.username)
      .then(() => this.Notifications.showAlert(
        this.gettextCatalog.getString('Success!'),
        this.gettextCatalog.getString('Force Password Reset Success!'),
      ).result)
      .then(() => this.cancelForm());
  }

  onShowResetPasswordConfirm() {
    return this.Notifications.showComplexDialog({
      template: resetPasswordDialogTemplate,
      resolve: {
        username: () => this.username,
      },
    }).result.then(() => {
      this.$state.go('user-resetAccountPassword', {
        userId: this.userId,
        skipDirtyForms: true,
      });
    });
  }
}

export default class ResetPasswordButtonComponent {
  constructor() {
    this.template = resetPasswordButtonTemplate;
    this.controller = ResetPasswordButtonController;
    this.bindings = {
      username: '<',
      userId: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/components/reset-account-password/components/reset-password-button/reset-password-button-component.js